<kendo-treeview [nodes]="locations" textField="name" childrenField="items" [(expandedKeys)]="expandedKeys"
  expandBy="locationId" [filterable]="true" filterInputPlaceholder="{{'_General_Search_Text_' | translate }}" kendoTreeViewExpandable
  kendoTreeViewHierarchyBinding>
  <ng-template kendoTreeViewNodeTemplate let-dataItem>
    <span class="selectoritem" (click)="showClick(dataItem)"
      [ngClass]="{'disableNode': dataItem.isUser === false,'itemactive' : selectedUserId == dataItem.id && dataItem.isUser === false}">
      {{ dataItem.name }}
    </span>

  </ng-template>
</kendo-treeview>
